import React, { useState } from 'react';

function NewsletterSubscribe() {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const res = await fetch('/api/newsletter/subscribe', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, name })
            });
            const data = await res.json();

            if (res.ok) {
                setSuccess(data.info || 'Fast geschafft! Bitte bestaetigt deine Anmeldung ueber den Link in der E-Mail.');
                setEmail('');
                setName('');
            } else {
                setError(data.error || 'Ein Fehler ist aufgetreten');
            }
        } catch (err) {
            setError('Ein Fehler ist aufgetreten. Bitte versuche es spaeter erneut.');
        }
        setLoading(false);
    };

    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card shadow">
                        <div className="card-body p-4">
                            <div className="text-center mb-4">
                                <h2>Newsletter abonnieren</h2>
                                <p className="text-muted">
                                    Bleib auf dem Laufenden ueber Kurse, Events und Neuigkeiten aus dem KI-Lab!
                                </p>
                            </div>

                            {success && (
                                <div className="alert alert-success">
                                    <strong>Vielen Dank!</strong><br />
                                    {success}
                                </div>
                            )}

                            {error && (
                                <div className="alert alert-danger">{error}</div>
                            )}

                            {!success && (
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">E-Mail-Adresse *</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)}
                                            placeholder="deine@email.de"
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Name (optional)</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={name}
                                            onChange={e => setName(e.target.value)}
                                            placeholder="Dein Name"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <small className="text-muted">
                                            Mit der Anmeldung erklaerst du dich damit einverstanden, regelmaessig
                                            Informationen per E-Mail zu erhalten. Du kannst dich jederzeit abmelden.
                                        </small>
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-primary w-100"
                                        disabled={loading}
                                    >
                                        {loading ? 'Wird gesendet...' : 'Newsletter abonnieren'}
                                    </button>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NewsletterSubscribe;
